/**
 * Performance PDP — flavor pills backed by Shopify variants (single product).
 */
(function () {
  'use strict';

  if (window.__PERFORMANCE_PDP_ENHANCEMENTS__ !== true) {
    return;
  }

  var root = document.getElementById('product-template');
  if (!root || !root.hasAttribute('data-performance-flavor-variants')) {
    return;
  }

  function flavorDescEl() {
    return root.querySelector('[data-performance-flavor-desc]');
  }

  function variantTitleEl() {
    return root.querySelector('[data-performance-variant-title]');
  }

  function productForm() {
    return root.querySelector('form[data-variants]');
  }

  function variantsFromForm() {
    var form = productForm();
    if (!form) return [];
    try {
      return JSON.parse(form.dataset.variants || '[]');
    } catch (e) {
      return [];
    }
  }

  function variantFromInput(input) {
    if (!input) return null;
    var variantId = input.getAttribute('data-variant-id');
    var variants = variantsFromForm();
    var match = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (match) return match;
    var title = (input.getAttribute('data-variant-title') || '').trim();
    if (title) return { id: variantId, title: title };
    return null;
  }

  function syncVariantTitleFromInput(input) {
    var titleEl = variantTitleEl();
    if (!titleEl || !input) return;
    var variant = variantFromInput(input);
    if (variant && variant.title) {
      titleEl.textContent = variant.title;
    }
  }

  function syncVariantTitle(variant) {
    var titleEl = variantTitleEl();
    if (!titleEl || !variant || !variant.title) return;
    titleEl.textContent = variant.title;
  }

  function checkedFlavorInput() {
    return root.querySelector('.metafield-variations-pill-input:checked');
  }

  function flavorTemplateForVariantId(variantId) {
    if (!variantId) return null;
    return root.querySelector(
      'template.performance-flavor-desc-template[data-variant-id="' + variantId + '"]'
    );
  }

  function syncFlavorDescriptionFromInput(input) {
    var desc = flavorDescEl();
    if (!desc || !input) return;

    var variantId = input.getAttribute('data-variant-id');
    var tmpl = flavorTemplateForVariantId(variantId);
    if (tmpl && tmpl.innerHTML.trim()) {
      desc.innerHTML = tmpl.innerHTML;
      return;
    }

    var text = (input.getAttribute('data-flavor-desc') || '').trim();
    if (!text) {
      desc.innerHTML = '';
      return;
    }

    desc.innerHTML = '<p>' + text.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</p>';
  }

  function syncFlavorDescriptionFromVariant(variant) {
    if (!variant) return;
    var input = root.querySelector(
      '.metafield-variations-pill-input[data-variant-id="' + variant.id + '"]'
    );
    if (input) {
      syncFlavorDescriptionFromInput(input);
      return;
    }
    syncFlavorDescriptionFromInput(checkedFlavorInput());
  }

  function accordionRoot() {
    return root.querySelector('[data-performance-variant-accordion]');
  }

  function syncAccordionPanels(variantId, variantTitle) {
    var accordion = accordionRoot();
    if (!accordion || !variantId) return;

    accordion
      .querySelectorAll('[data-performance-accordion-panel]')
      .forEach(function (item) {
        var panelIndex = item.getAttribute('data-performance-accordion-panel');
        var contentEl = item.querySelector('[data-performance-accordion-content]');
        var tmpl = root.querySelector(
          'template.performance-accordion-panel-template[data-variant-id="' +
            variantId +
            '"][data-panel-index="' +
            panelIndex +
            '"]'
        );

        if (tmpl && tmpl.innerHTML.trim()) {
          item.removeAttribute('hidden');
          item.style.display = '';
          if (contentEl) contentEl.innerHTML = tmpl.innerHTML;

          var titleTmpl = root.querySelector(
            'template.performance-accordion-panel-title-template[data-variant-id="' +
              variantId +
              '"][data-panel-index="' +
              panelIndex +
              '"]'
          );
          if (titleTmpl) {
            var heading = item.querySelector('[data-performance-accordion-title]');
            if (heading) heading.textContent = titleTmpl.innerHTML.trim();
          }
        } else {
          item.setAttribute('hidden', '');
          item.style.display = 'none';
          if (contentEl) contentEl.innerHTML = '';
        }
      });

    if (variantTitle) {
      var panelOne = accordion.querySelector(
        '[data-performance-accordion-panel="1"]:not([hidden]) [data-performance-accordion-title]'
      );
      var titleTmplOne = root.querySelector(
        'template.performance-accordion-panel-title-template[data-variant-id="' +
          variantId +
          '"][data-panel-index="1"]'
      );
      if (panelOne && titleTmplOne) {
        panelOne.textContent = titleTmplOne.innerHTML.trim();
      } else if (panelOne && !titleTmplOne) {
        panelOne.textContent = 'What is ' + variantTitle + '?';
      }
    }
  }

  function dispatchFlavorChanged(detail) {
    try {
      document.dispatchEvent(
        new CustomEvent('performance-pdp:flavor-variant-changed', {
          bubbles: true,
          detail: detail || {},
        })
      );
    } catch (e) {}
  }

  function syncFromInput(input) {
    var variant = variantFromInput(input);
    syncFlavorDescriptionFromInput(input);
    syncVariantTitleFromInput(input);
    if (input) {
      syncAccordionPanels(input.getAttribute('data-variant-id'), variant && variant.title);
    }
    dispatchFlavorChanged({ input: input });
  }

  root.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('metafield-variations-pill-input')) {
      return;
    }
    syncFromInput(e.target);
  });

  window.addEventListener('variantChange.ecomify.product', function (ev) {
    syncFlavorDescriptionFromVariant(ev.detail);
    syncVariantTitle(ev.detail);
    if (ev.detail) {
      syncAccordionPanels(ev.detail.id, ev.detail.title);
    }
    dispatchFlavorChanged({ variant: ev.detail });
  });

  var initialInput = checkedFlavorInput();
  if (initialInput) {
    syncFromInput(initialInput);
  }
})();
